export const Weekly = 'Semaines';
export const Monthly = 'Mois';
export const Quarterly = 'Trimestres';
export const Annual = 'Années';
